import * as React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isArray } from "underscore";
import { applyFilterByMainKeyAndSlug, clearFilterByKeyAndSelectionIndex, } from "../../store/slice/ProductListingFilterApplied";
import Helper from "../../support/Helper";
import useReduxState from "src/hooks/useReduxState";

const CommonFilterBoxField = (props) => {
  const { main_label, slug, onFacetsChange } = props;
  const dispatch = useDispatch();
  const list = useSelector((state) => state.entities.ProductListingAPICall.data);
  const filter = useSelector((state) => state.entities.ProductListingFilterApplied);
  const [firstServerCall, setFirstServerCall] = useState(true);
  const [param, setParam] = useState("");
  const [listOfLI, SetListOfLI] = useState([]);
  const filter_box_expanded = useSelector((state) => state.entities.ProductListingSettings.filter_box_expanded);
  const [firstServerCallFilter, setFirstServerCallFilter] = useReduxState(true, 'setFirstServerCallFilter');
  const [optionsAvailable, setOptionsAvailable] = useState([]);
  useEffect(() => {
    async function fetchHere() {
      processList();
      await setFirstServerCall(false);
    }

    fetchHere();
  }, []);

  useEffect(() => {
    async function fetchHere() {
      await processList();
    }

    if (firstServerCall === false) {
      fetchHere();
    }
  }, [list]);

  const processList = () => {
    if (list["@search.facets"] !== undefined && list["@search.facets"][slug] !== undefined) {
      SetListOfLI(list["@search.facets"][slug][slug]);
      setOptionsAvailable(list["@search.facets"][slug]);
    }
  };
  const getAppliedFilterStatusByValue = (value) => {
    if (filter[slug]?.selection?.length > 0) {
      let decision = false;
      decision =
        filter[slug].selection?.find((v) => v.value === value) || false;
      return decision;
    }
    return false;
  };

  /**
   * Story #   : 5601
   * Change    : Below useEffect will be used for single category falls than default selected
   * Change by : Pankaj
   * Date      : 09 Feb 2023
   */
  useEffect(() => {
    if (param === "" && slug === "Categories") {
      if (list["@search.facets"] && list["@search.facets"]["Categories"] &&
        list["@search.facets"]["Categories"]["Categories"] && isArray(list["@search.facets"]["Categories"]["Categories"]) &&
        list["@search.facets"]["Categories"]["Categories"].length === 1
      ) {
        // Get Nth Child Value
        let nestedObj = findNestedObj(
          list["@search.facets"]["Categories"]["Categories"],
          "value"
        );
        if (nestedObj && Object.keys(nestedObj).length > 0 && nestedObj.value) {
          let k = {
            key: slug,
            main_label: main_label,
            value: nestedObj.value,
          };
          if (nestedObj.Level !== undefined) {
            k.hidden_payload = {
              Level: nestedObj.Level,
            };
          }

          dispatch(applyFilterByMainKeyAndSlug(k));
        }
      }
      // DT - 4/09/23 - Bug 13949: Performance: Unwanted Search, Inventory & Price API calls happening in global search
      setTimeout(() => {
        if (firstServerCallFilter) {
          setFirstServerCallFilter(false)
        }
      }, 1000);

    }
  }, [param]);

  const findNestedObj = (entireObj, keyToFind) => {
    /***
     * Author: Trilok Sain
     * Date: 16-02-2023
     * Reason: Auto select last single child  when there in only single item on each level
     */
    let foundObj = {};
    JSON.stringify(entireObj, (_, nestedValue) => {
      if (Array.isArray(nestedValue) && nestedValue.length > 1) {
        foundObj = undefined;
      } else if (nestedValue && nestedValue[keyToFind] && foundObj) {
        foundObj = nestedValue;
      }
      return nestedValue;
    });
    return foundObj;
  };

  const searchData = (parentItem, dataArray, searchTerm) => {
    try {
      return dataArray.flatMap((obj) => {
        const objHasSearchTerm = Object.entries(obj).some(
          ([key, value]) =>
            key !== "value" &&
            String(value).toLowerCase().includes(searchTerm.toLowerCase())
        );

        if (objHasSearchTerm && !obj.Categories) return [obj];

        const matchedChildren = searchData(
          parentItem,
          obj.Categories ?? [],
          searchTerm
        );

        return objHasSearchTerm || matchedChildren.length > 0
          ? [
            {
              ...obj,
              Categories: matchedChildren,
            },
          ]
          : [];
      });
    } catch (err) {
      return [];
    }
  };

  const checkParent = (obj) => {
    try {
      if (param !== "" && obj.Categories !== undefined && obj.Categories !== null && obj.Categories.length > 0) {
        return searchData(obj.value, obj.Categories, param);
      }
      if ((param !== "" && obj.Level === 1 && obj.Categories === undefined) || obj.Categories === null) {
        if (obj.value.trim().toLowerCase().includes(param.toLowerCase())) {
          return obj;
        }
        return null;
      }
      return obj;
    } catch (err) {
      return [];
    }
  };

  const getDisplayDecision = (v, i) => {
    if (slug === "Categories") {
      return (
        param !== "" &&
        (checkParent(v) === null || checkParent(v) === undefined || checkParent(v).length === 0)
      );
    }
    return !param ||
      (param && v.value.toLowerCase().includes(param.toLowerCase()))
      ? ""
      : "none";
  };
  const listMaker = (v, i) => {
    return (
      <React.Fragment key={i}>
        <li style={{ display: getDisplayDecision(v, i) ? "none" : "" }}>
          <a
            autoFocus={getAppliedFilterStatusByValue(v.value)}
            className={
              filter[slug]?.selection?.find((exisitingVal) => v.value === exisitingVal.value)
                ? "active" : ""}
            style={{ cursor: "pointer", fontWeight: v.Level === 1 ? "bold" : "", }}
            onClick={() => {
              let d = getAppliedFilterStatusByValue(v.value);
              if (!d) {
                let k = {
                  key: slug,
                  main_label: main_label,
                  value: v.value,
                };
                if (v.Level !== undefined) {
                  k.hidden_payload = {
                    Level: v.Level,
                  };
                }
                dispatch(applyFilterByMainKeyAndSlug(k));
                onFacetsChange({ key: slug, value: v.value });
              } else {
                dispatch(
                  clearFilterByKeyAndSelectionIndex({
                    key: slug,
                    selectionIndex: d.i,
                  })
                );
              }
            }}
          >
            {v.main_label}
            <span className="p-1 filter-count">({v.count}) </span>
          </a>
          {v[slug] !== undefined &&
            v[slug].length > 0 &&
            param !== "" &&
            checkParent(v)?.map((v_in, i_in) => (
              <ul key={Helper.UUID()}>{listMaker(v_in, i_in)}</ul>
            ))}
          {v[slug] !== undefined &&
            v[slug].length > 0 &&
            param === "" &&
            v[slug].map((v_in, i_in) => (
              <ul key={Helper.UUID()}>{listMaker(v_in, i_in)}</ul>
            ))}
        </li>
      </React.Fragment>
    );
  };
  return (
    <>
      {optionsAvailable !== undefined &&
        optionsAvailable[slug] !== undefined &&
        optionsAvailable[slug].length > 0 &&
        main_label !== "Attributes" && (
          <div className="col-auto mb-3">
            <div
              className={
                filter_box_expanded ? "filterbox expanded" : "filterbox"
              }
            >
              <div className="filterbox-header">{main_label}</div>
              <div className="product_filter_box filterbox-body">
                <form action="" className="search-filter">
                  <div className="bs5 input-group flex-nowrap input-icon-right"
                    id="searchText">
                    <input name="search" id="input_categoryId" type="text"
                      placeholder={"Search " + (main_label.toLocaleLowerCase() === "category"
                        ? "a " : "") + main_label}
                      onChange={async (e) => {
                        const delayDebounceFn = setTimeout(async () => {
                          setParam(e.target.value);
                        }, 500);
                        return () => clearTimeout(delayDebounceFn);
                      }}
                      autoComplete="off"
                    />
                    <span className="bs5 input-group-addon flex-nowrap">
                      <span className="fa fa-search text-black-stone" />
                    </span>
                  </div>
                  <ul className="hierarchical">
                    {listOfLI.length && (
                      <>
                        {listOfLI.map((v, i) => (
                          <React.Fragment key={Helper.UUID()}>
                            {listMaker(v, i)}
                          </React.Fragment>
                        ))}
                      </>
                    )}
                  </ul>
                </form>
              </div>
            </div>
          </div>
        )}
    </>
  );
};

export default CommonFilterBoxField;
